(() => {
  const pendingAlignment = new WeakMap();
  const observedGrids = new WeakSet();
  const alignColourRows = grid => {
    const cards = Array.from(grid.children).filter(card => card.matches('[data-product-handle]'));
    const entries = cards.map(card => ({card, meta: card.querySelector('.grid-product__meta')})).filter(entry => entry.meta);
    entries.forEach(({meta}) => meta.style.removeProperty('min-height'));
    const rows = new Map();
    entries.forEach(entry => {
      const top = Math.round(entry.card.offsetTop);
      const row = rows.get(top) || [];
      row.push({meta: entry.meta, height: entry.meta.getBoundingClientRect().height});
      rows.set(top, row);
    });
    rows.forEach(row => {
      const height = Math.ceil(Math.max(...row.map(entry => entry.height)));
      row.forEach(({meta}) => {meta.style.minHeight = `${height}px`;});
    });
  };
  const queueAlignment = grid => {
    cancelAnimationFrame(pendingAlignment.get(grid));
    pendingAlignment.set(grid, requestAnimationFrame(() => {
      if (grid.isConnected) alignColourRows(grid);
    }));
  };
  const watchGrid = grid => {
    if (observedGrids.has(grid)) return;
    observedGrids.add(grid);
    let width = 0;
    const observer = new ResizeObserver(entries => {
      const nextWidth = entries[0].contentRect.width;
      if (nextWidth !== width) {width = nextWidth; queueAlignment(grid);}
    });
    observer.observe(grid);
    new MutationObserver(() => queueAlignment(grid)).observe(grid, {childList: true});
    document.fonts?.ready.then(() => queueAlignment(grid));
  };
  const sortGrid = (section, value) => {
    const grid = section.querySelector('.grid--uniform[data-scroll-to]');
    if (!grid) return;
    const cards = Array.from(grid.children).filter(card => card.matches('[data-product-handle]'));
    cards.forEach((card, index) => { if (!card.dataset.discoveryOrder) card.dataset.discoveryOrder = String(index + 1); });
    const direction = value.endsWith('descending') ? -1 : 1;
    const sorted = cards.slice().sort((a, b) => {
      if (value.startsWith('price-')) return direction * (Number(a.dataset.discoveryPrice) - Number(b.dataset.discoveryPrice));
      if (value.startsWith('title-')) return direction * a.dataset.discoveryTitle.localeCompare(b.dataset.discoveryTitle, document.documentElement.lang);
      if (value.startsWith('created-')) return direction * (Number(a.dataset.discoveryCreated) - Number(b.dataset.discoveryCreated));
      return Number(a.dataset.discoveryOrder) - Number(b.dataset.discoveryOrder);
    });
    sorted.forEach(card => grid.append(card));
    watchGrid(grid);
    queueAlignment(grid);
  };
  const init = () => {
    document.querySelectorAll('[data-discovery-grid]').forEach(section => {
      const select = section.querySelector('#SortBy');
      if (select?.hasAttribute('data-moebe-sort')) {
        const grid = section.querySelector('.grid--uniform[data-scroll-to]');
        if (grid) {watchGrid(grid); queueAlignment(grid);}
      } else sortGrid(section, select?.value || 'manual');
    });
  };
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-discovery-grid] #SortBy')) return;
    if (event.target.hasAttribute('data-moebe-sort')) return;
    event.stopImmediatePropagation();
    const section = event.target.closest('[data-discovery-grid]');
    sortGrid(section, event.target.value);
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.history.replaceState({}, '', url);
  }, true);
  document.addEventListener('toggle', event => {
    if (!event.target.matches?.('.moebe-menu__category[open]')) return;
    event.target.closest('moebe-mobile-menu')?.querySelectorAll('.moebe-menu__category[open]').forEach(other => {
      if (other !== event.target) other.open = false;
    });
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('.moebe-menu__category a');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) window.theme?.NavDrawer?.close();
  });
  document.addEventListener('keydown', event => {
    const summary = event.target.closest('[data-discovery-menu] > summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopImmediatePropagation();
      details.open = !details.open;
      summary.setAttribute('aria-expanded', String(details.open));
    } else if (event.key === 'Escape') {
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    }
  }, true);
  const markAnchor = () => {
    document.querySelectorAll('.collection-navigation [data-discovery-links] a[href*="#"]').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      const active = url.pathname === window.location.pathname && url.hash === window.location.hash;
      link.classList.toggle('bold', active);
      if (active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
    });
  };
  window.addEventListener('hashchange', markAnchor);
  document.addEventListener('shopify:section:load', () => {init(); markAnchor();});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {init(); markAnchor();});
  else {init(); markAnchor();}
})();
